<span class="tag k-d-flex k-align-items-center" [ngClass]="['tag-' + theme, size ? 'tag-' + size : '']">
  <ng-content></ng-content>
</span>
